module.exports = __webpack_public_path__ + "static/media/selecta_original_preparada.bf2d9b9a.png";